// import React, { useState } from "react";
import { Footer, Navbar2 } from "../components";
// import { Modal } from "../components";
// import { AppButton } from "../utils";
// import { BiRupee } from "react-icons/bi";
// import ProgressBar from "../components/ProgressBar";


function DonateCoverUp() {
  return (
    <div className="h-full">
      <div className="mx-auto max-w-7xl">
        <Navbar2 />
      </div>
      <h1 className="text-center font-montserrat font-bold text-4xl md:text-5xl lg:text-7xl text-mix-400 my-64">
        Donate Page Will Come Soon...
      </h1>
      <Footer />
    </div>
  );
}

function Donate(props) {
  // let [isOpen, setIsOpen] = useState(false);

  // function openModal() {
  //   setIsOpen(!isOpen);
  // }

  return (
    // <>
    //   <div className="h-full">
    //     <div className="mx-auto max-w-7xl">
    //       <Navbar />
    //     </div>
    //     <div className="max-w-7xl mx-auto">
    //       <h1 className="font-semibold text-3xl text-mix-400 text-center pt-10 pb-14">
    //         Help the children.
    //         <span>
    //           <h1>Make big changes and help the world</h1>
    //         </span>
    //       </h1>
    //     </div>

    //     <ProgressBar />

    //     <div className="my-8 bg-purple-100 text-center w-1/2 mx-auto rounded-lg">
    //       <div className="text-mix-400 my-4">
    //         <h1 className="pt-8 text-xl">
    //           FINANCIAL DONATION
    //           <span>
    //             <h1>TO DRISHTI</h1>
    //           </span>
    //         </h1>
    //       </div>
    //       <div>
    //         <h5 className="bg-purple-100">I want to contribute:</h5>
    //         <div className="flex justify-center items-center p-2">
    //           <BiRupee fontSize={30} className="cursor-pointer" />
    //           <input className="p-4" placeholder="100"></input>
    //         </div>
    //         <div className="flex items-center justify-center mb-8">
    //           <h5 className="">Value in INR</h5>
    //           <BiRupee fontSize={20} className="cursor-pointer" />
    //         </div>
    //         <div className="pb-12 space-x-2">
    //           <input type="checkbox" name="Anonymous"></input>
    //           <label for="Anonymous">Anonymous donation</label>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="-mt-14 justify-center flex">
    //       <AppButton text="Next Step" onClick={openModal} />
    //     </div>

    //     <div className="max-w-7xl mx-auto">
    //       <h1 className="my-14 text-mix-400 text-xl text-center">
    //         ALL DONATIONS ARE GREATLY APPRECIATED
    //       </h1>
    //     </div>
    //     <p className="text-center text-gray-500 mx-60">
    //       Elit nisi enim exercitation laborum reprehenderit ex mollit incididunt
    //       ut laborum deserunt incididunt dolore tempor. Ipsum consequat dolor
    //       officia minim anim magna consequat consectetur esse occaecat veniam ex
    //       consequat.
    //     </p>
    //     <Footer />
    //   </div>
    //   {isOpen && <Modal isOpen={isOpen} setIsOpen={setIsOpen} />}
    // </>
    <DonateCoverUp />
  );

}

export default Donate;
